module.exports = __webpack_public_path__ + "static/media/gym-1.4.18c921c8.png";